import { CONFIG } from "~/config";
import { unsetDetail } from "~/state/detail/state";
import { store } from "~/state/store";
import { isDetailActive } from "~/util/detail";
import { node } from "~/util/dom";

interface ICreateMapyLogoProps {
	hidden?: boolean;
	large?: boolean;
}

export function createMapyLogo({
	hidden = false,
	large = false,
}: ICreateMapyLogoProps) {
	const container = node("span", { className: "control-mapy-logo logo-container print" });

	container.append(node("mapy-logo", { mode: "expanded" }));
	container.addEventListener("click", () => {
		if (CONFIG.inFrame) {
			Mapy.Util.openInNewWindow();
		} else {
			if (isDetailActive(store.getState())) {
				store.dispatch(unsetDetail());
			}

			Mapy.getComponent("search").activate();
			Mapy.getComponent("layout").setWidth(0);
			Mapy.getComponent("history")?.save();
		}
	});

	if (hidden) {
		container.classList.add("hidden");
	}

	if (large) {
		container.classList.add("large");
	}

	return container;
}
